"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPickerColorFieldRoot = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _colorPickerTheme = require("../../../../colorPickerTheme");
const ColorPickerColorFieldRoot = (0, _styled.default)("div")`
    width: 100%;
    height: 192px;
    margin-bottom: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _colorPickerTheme.colorPickerTheme.colorPicker.marginBottom(themeMode);
}};
    position: relative;
    cursor: crosshair;
    &:before,
    &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    &:before {
        background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    }
    &:after {
        background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
    }
    &:focus {
        outline: 2px solid ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _colorPickerTheme.colorPickerTheme.colorPicker.focusColor(themeMode);
}};
        outline-offset: 3px;
    }
`;
exports.ColorPickerColorFieldRoot = ColorPickerColorFieldRoot;
//# sourceMappingURL=ColorPickerColorFieldRoot.js.map